import { Download, ExternalLink, FileText, Loader2 } from 'lucide-react';
import { CARD, SECONDARY } from './ui';

interface Props {
  reportUrl: string | null;
  canGenerate: boolean;
  isOnline: boolean;
  isGenerating: boolean;
  layout: 'phone' | 'desktop';
  onGenerate(): void;
}

export function PdfCard({ reportUrl, canGenerate, isOnline, isGenerating, layout, onGenerate }: Props) {
  if (!reportUrl) {
    if (!canGenerate) return null;
    return (
      <button type="button" onClick={onGenerate} disabled={!isOnline || isGenerating}
        className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl bg-slate-900 text-sm font-semibold text-white shadow-sm active:bg-slate-800 disabled:opacity-50">
        {isGenerating ? <><Loader2 size={18} className="animate-spin" /> Generating PDF...</> : <><FileText size={18} /> Generate PDF Preview</>}
      </button>
    );
  }
  return (
    <div className={`${CARD} space-y-3`}>
      <h3 className="text-sm font-bold text-slate-900">Report PDF</h3>
      {layout === 'desktop' && (
        <iframe title="Report PDF preview" src={reportUrl} className="h-[70vh] w-full rounded-xl border border-slate-200" />
      )}
      <div className="grid gap-2 sm:grid-cols-2">
        <a href={reportUrl} target="_blank" rel="noopener noreferrer"
          className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-xl bg-emerald-50 text-sm font-semibold text-emerald-700 active:bg-emerald-100">
          <ExternalLink size={16} /> View PDF
        </a>
        {/* A cross-origin Storage URL ignores `download`, so this must open a new tab or it
            navigates the installed app away (no way back, pending autosave lost). */}
        <a href={reportUrl} download target="_blank" rel="noopener noreferrer" className={`${SECONDARY} min-h-[52px]`}>
          <Download size={16} /> Download PDF
        </a>
      </div>
      <button type="button" onClick={onGenerate} disabled={!isOnline || isGenerating} className={`${SECONDARY} w-full text-xs`}>
        {isGenerating ? <Loader2 size={14} className="animate-spin" /> : null} Regenerate PDF
      </button>
    </div>
  );
}
